// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UtaH-","title":"styles_title__2RMP_"};